/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PlatformKillswitchMutationResult = {
  prescriptionId: string;
  replayed: boolean;
  state: string;
  version: number;
};

/** @internal */
export const PlatformKillswitchMutationResult$inboundSchema: z.ZodMiniType<
  PlatformKillswitchMutationResult,
  unknown
> = z.pipe(
  z.object({
    prescription_id: z.string(),
    replayed: z.boolean(),
    state: z.string(),
    version: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "prescription_id": "prescriptionId",
    });
  }),
);

export function platformKillswitchMutationResultFromJSON(
  jsonString: string,
): SafeParseResult<PlatformKillswitchMutationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PlatformKillswitchMutationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PlatformKillswitchMutationResult' from JSON`,
  );
}
